// © Microsoft Corporation. All rights reserved.
/**
 * Contract related to local dev workflow
 */
export var ConfigOrigin;
(function (ConfigOrigin) {
    // Configs are fetched from remote
    ConfigOrigin[ConfigOrigin["Production"] = 0] = "Production";
    // Configs are fetched from local file system
    ConfigOrigin[ConfigOrigin["Local"] = 1] = "Local";
})(ConfigOrigin || (ConfigOrigin = {}));
//# sourceMappingURL=ConfigOrigin.js.map